
class scrollEventClass {
	constructor ( elem ) {
		this.container= elem;
		this.scrollEvtInit();
		this.windowResizeEvt();
	}
	
	scrollEvtInit () {
		this.init();
		this.handlerEvent= this.handlerset();
		this.container.addEventListener('scroll', this.handlerEvent, {passive: true});
	}

	destroy () {
		this.container.removeEventListener('scroll', this.handlerEvent, {passive: true});
	}

	init () {
		this.scrollType= null;
		this.scrollImmediatelyCb= null;
		this.scrollThrottleCb= null;
		this.currentOnCallback= null;
	}
	
	reSetElem ( sect, obj ) {
		// this.init();
		if( obj ) {
			this.scrollType= obj.scrollType;
			this.scrollThrottleCb= obj.throttle;
			this.scrollImmediatelyCb= obj.immediately;
			this.currentOnCallback= obj.currentOnCallback;
			this.addReset= obj.addReset;
		}
		this.sections= sect;
		this.sectionLen= this.sections.length;
		this.sectionTop= [];
		this.sectionBottom= [];
		this.passedIndex= null;
		this.passedElem= null;
		this.currentIndex= null;
		this.currentElem= null;
		this.windowTopLast= null;
	}
	
	reSet () {
		this.wininnerHeight= window.innerHeight;
		this.sectionTop= [];
		this.sectionBottom= [];
		_jh.each( this.sections, (idx, val)=> {
			this.sectionTop[idx]= this.offset(val).top;
			this.sectionBottom[idx]= this.sectionTop[idx] + val.offsetHeight;
			val.dataset.jhcScrollIndex= idx;
		});
		this.addReset && this.addReset(this);
	}

	reSetEvt () { return (e)=> { this.reSet(); } }

	offset ( elem ) {
		const rect= elem.getBoundingClientRect()
				, win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset,
		}
	}

	windowResizeEvt () { window.addEventListener('resize', this.reSetEvt()); }

	offOthers ( index ) {
		_jh.each(this.sections, (i,v)=> {
			if( i === index ) return;
			v.classList.remove('on');
		});
	}

	betweenTopBottom ( top, bottom, winPos ) {
		return ( winPos > top && winPos < bottom )
	}

	betweenCallback ( index, scsoll ) {}

	currentOnDefault () {
		_jh.each( this.sectionTop, (i, v)=> {
			const btw= this.betweenTopBottom(v, this.sectionBottom[i], this.windowMidBtm);
			if( btw ) 
			{
				this.currentIndex= i;
				this.currentElem= this.sections[i];
				this.betweenCallback && this.betweenCallback(i, this);
			}

			if( (this.windowMidBtm > v) ||
					(i === (this.sectionLen-1) && this.windowMiddle > v) ) 
			{
				this.scrollCurrentCb && this.scrollCurrentCb(this);
				if( this.sections.length > 0 && !this.sections[i].dataset.hasOwnProperty('scrollOff') && 
					this.passedIndex !== i && !this.sections[i].classList.contains('on') ) 
				{
					this.passedIndex= i;
					this.passedElem= this.sections[i];
					this.sections[i].classList.add('on');
					this.currentOnCallback && this.currentOnCallback(this);
				}
			}
		});
	}

	handlerset() {
		let breakOut= true,
				timer;
		this.passedIndex= null;
		this.currentIndex= null;
		this.windowTopLast= null;

		const calcOffset= ()=> {
			this.windowTop= window.pageYOffset;
			this.windowTopMid= this.windowTop + ((this.windowBottom - this.windowTop) / 3);
			this.windowMiddle= this.windowTop + ((this.windowBottom - this.windowTop) / 2);
			this.windowMidBtm= this.windowTop + ((this.windowBottom - this.windowTop) * .6);
			this.windowBottom= this.windowTop + this.wininnerHeight;
		}

		

		const scrollEvent= {
			scrollTypeEvt: ( type )=> {
				scrollEvent[type]();
			},
			immediately: (e)=> {
				this.scrollImmediatelyCb && this.scrollImmediatelyCb(this);
			},
			throttle: ()=> {
				if( !timer ) {
					timer= setTimeout( (e)=> {
						timer = null;
						this.scrollThrottleCb && this.scrollThrottleCb(this);
					}, 200);
				}
			}
		}
		
		this.scrollEvent= (e)=> {
			if( this.scrollType ) {
				calcOffset();
				scrollEvent.scrollTypeEvt(this.scrollType);
				this.windowTopLast= window.pageYOffset;
			} else {
				calcOffset();
				scrollEvent.immediately(e);
				scrollEvent.throttle();
				this.windowTopLast= window.pageYOffset;
			}
		}
		return this.scrollEvent;
	
	}

}

export const scrollEvent= scrollEventClass;